<template>
	
</template>

<script>

	class Form {
		
	}

	export default {
		data() {
			return {
				model: {}
			}
		},

		methods: {
			/**
			 * This function is to save the model by an ajax POST request.
			 * Every update done on the object are properly handled by the
			 * back-end, which retrieve the obejct passed to by the POST
			 * and updates the fields correctly with the new ones provided.
			 */
			save() {

			},

			/**
			 * This function is to delete the model identified by the id
			 * contained into the ajax POST request.
			 * The POST's body contains the model itself.
			 */
			delete() {

			}
		}
	}
</script>